type DataTableProps<T extends Record<string, string | number | null | undefined>> = {
  columns: Array<{ key: keyof T; label: string }>;
  rows: T[];
  emptyLabel?: string;
};

export function DataTable<T extends Record<string, string | number | null | undefined>>({
  columns,
  rows,
  emptyLabel = "Sem dados no recorte atual."
}: DataTableProps<T>) {
  return (
    <div className="table-wrap">
      <table className="data-table">
        <thead>
          <tr>
            {columns.map((column) => <th key={String(column.key)}>{column.label}</th>)}
          </tr>
        </thead>
        <tbody>
          {rows.length ? rows.map((row, index) => (
            <tr key={index}>
              {columns.map((column) => <td key={String(column.key)}>{row[column.key] ?? "-"}</td>)}
            </tr>
          )) : (
            <tr>
              <td colSpan={columns.length}>{emptyLabel}</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
